import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Carousel from '../carousel/Carousel';
import { useMediumUpBp } from '../../hooks/useMedia';

const IconsCarousel = (props) => {
  const { colourScheme, iconRows, titleColour, title, noBreakline, customPadding, sectionId } = props;
  const isMediumUp = useMediumUpBp();

  const componentClasses = classNames('icon-carousel', {
    [`icon-carousel--${colourScheme}-scheme`]: colourScheme,
    [`titles--${titleColour}`]: titleColour,
    'icon-carousel-no-breakline': noBreakline,
    'icon-carousel--no-padding-top': customPadding === 'no-top',
    'icon-carousel--no-padding-bottom': customPadding === 'no-bottom',
    'icon-carousel--no-padding-top-bottom': customPadding === 'no-padding'
  });

  const CarouselSlides = iconRows.map((iconRow) => (
    <div key={iconRow.src || iconRow.icon} className="iconRow">
      {iconRow.icon ? <span className={`icon-carousel--Icon ${iconRow.icon}`} /> : null}
      {iconRow.label ? (
        <p>
          <strong>{iconRow.label}</strong>
        </p>
      ) : null}
      {iconRow.bigIcon ? <span className={iconRow.bigIcon} /> : null}
      {iconRow.src ? <article dangerouslySetInnerHTML={{ __html: props[iconRow.src] }} /> : null}
    </div>
  ));

  return (
    <section className={componentClasses}>
      {title && <h2 className="icon-carousel-title">{title}</h2>}
      <div className="icon-carousel-container" id={sectionId ? sectionId : ''}>
        {isMediumUp && (iconRows ? CarouselSlides : null)}
        {!isMediumUp && <Carousel options={{ slidesToShow: 1 }} slides={CarouselSlides} />}
      </div>
      {!noBreakline && <hr />}
    </section>
  );
};

IconsCarousel.propTypes = {
  title: PropTypes.string,
  sectionId: PropTypes.string,
  noBreakline: PropTypes.string,
  iconRows: PropTypes.array,
  colourScheme: PropTypes.oneOf([
    'grey',
    'dark-navy',
    'light-grey',
    'gradient',
    'teal',
    'teal-in-navy',
    'teal-in-teal'
  ]),
  titleColour: PropTypes.oneOf(['purple', 'dark-navy', 'teal'])
};

export default IconsCarousel;
